var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBookmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.714 7A.714.714 0 009 7.714v11.771l4.419-3.156a1 1 0 011.162 0L19 19.485V7.715A.715.715 0 0018.286 7H9.714zM7.795 5.795A2.714 2.714 0 019.715 5h8.57A2.714 2.714 0 0121 7.714V21.43a1 1 0 01-1.581.813L14 18.372l-5.419 3.87A1 1 0 017 21.43V7.714c0-.72.286-1.41.795-1.919z"
  })));
}
export default SvgMenuBookmarkOutline;